import { render } from "./viewComponent.vue?vue&type=template&id=4fb8a66a&scoped=true"
import script from "./viewComponent.vue?vue&type=script&lang=js"
export * from "./viewComponent.vue?vue&type=script&lang=js"

import "./viewComponent.vue?vue&type=style&index=0&id=4fb8a66a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fb8a66a"]])

export default __exports__